// extracted by mini-css-extract-plugin
module.exports = {"delete_dialog_header":"ConfirmDeleteDialog_delete_dialog_header__3mChj"};